module.exports = __webpack_public_path__ + "static/media/jaime.1eb3acaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/eshopex/jaime.jpg
// module id = 1215
// module chunks = 0